import React from 'react'
import PropTypes from 'prop-types'
import Helmet from 'react-helmet'

import favicon16 from '../assets/favicon16.png'
import favicon32 from '../assets/favicon32.png'
import favicon192 from '../assets/favicon192.png'
import appleTouchIcon from '../assets/appleTouchIcon.png'
import safariMaskIcon from '../assets/safariMaskIcon.svg'

import 'bootstrap/dist/css/bootstrap-grid.css'

import './reset.css'
import './index.css'

import { Footer, Header } from '../components'

const Layout = ({ children, data, location, ...props }) => (
  <div>
    <Helmet
      title={data.site.siteMetadata.title}
      meta={[
        { charset: 'UTF-8' },
        {
          name: 'description',
          content: 'ISKRAEMECO d.o.o. - Mjerenje i upravljanje energijom.',
        },
        { name: 'robots', content: 'index, follow' },
        { name: 'format-detection', content: 'telephone=no' },
      ]}
      link={[
        { rel: 'icon', sizes: ['16x16'], href: favicon16 },
        { rel: 'icon', sizes: ['32x32'], href: favicon32 },
        {
          rel: 'apple-touch-icon',
          sizes: ['180x180'],
          href: appleTouchIcon,
        },
        {
          rel: 'icon',
          sizes: ['192x192'],
          href: favicon192,
        },
        { rel: 'mask-icon', href: safariMaskIcon, color: '#ffffff' },
      ]}
    >
      <html lang="hr" />
    </Helmet>
    <Header
      siteTitle={data.site.siteMetadata.title}
      pathname={location.pathname}
    />
    <div className="site-content-wrapper">
      {children({ ...props, location, data })}
    </div>
    <div className="index-footer-wrapper">
      <div className="container">
        <Footer />
      </div>
    </div>
  </div>
)

Layout.propTypes = {
  children: PropTypes.func,
}

export default Layout

export const query = graphql`
  query SiteTitleQuery {
    site {
      siteMetadata {
        title
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/layouts/index.js